<div class="wrapper">
  <div class="container px-0">
    <div class="row justify-content-center allergy-card">
      <div class="col-md-12">
        <div class="main-info">
          <strong>{{ 'madisonphi.phiAccessPermissionTitle' | translate }}</strong>
        </div>
      </div>
      <div class="col-6 col-sm-5 col-md-3" *ngIf="get_PHIdetails.length == 0">
        <div class="bg-info card h-100 mb-3 p-3 text-center text-white" (click)="modalAddPHI()">
          <span class="bg-white icon mb-3">
            <img height="23" src="../../../assets/images/Icons/plus.svg">
          </span>
          <h6 class="font-weight-normal mb-0">{{ 'madisonphi.addIndividual' | translate }}</h6>
        </div>
      </div>
      <div class="col-6 col-sm-5 col-md-3" *ngIf="get_PHIdetails.length == 0">
        <div class="card mb-3 h-100 p-3 text-center text-info">
          <span class="icon mb-3">
            <img height="23" src="../../../assets/images/Icons/cross.svg">
          </span>
          <h6 class="font-weight-normal mb-0">{{ 'madisonphi.noContacts' | translate }}</h6>
        </div>
      </div>
      <div class="col-12 mt-3" *ngIf="get_PHIdetails.length > 0">
        <button class="btn btn-primary" style="float: right;" type="button" (click)="modalAddPHI()">{{ 'madisonphi.addAnother' | translate }}</button>
      </div>
      <ng-container *ngIf="get_PHIdetails.length >0 else notFoundPA">
        <div class="container">
          <div class="specialist-list pt-4">
            <div class="form-row">
              <div class="col-lg-6" *ngFor="let record of get_PHIdetails">
                <div class="card p-3">
                  <div class="card-body p-0 d-flex flex-column justify-content-around text-left w-100">
                    <div class="d-flex flex-sm-row justify-content-between mb-2 position-absolute mr-1r">
                      <div class="ctabtns d-flex">
                        <a class="mr-3" (click)="editPHI(record)">
                          <i title="Edit"
                             class="fas fa-edit text-dark"></i>
                        </a>
                        <a (click)="deletePHI(record)">
                          <i title="Delete"
                             class="far fa-trash-alt text-danger"></i>
                        </a>
                      </div>
                    </div>
                    <div class="mb-2 mw-action">
                      <span class="font-weight-bold">{{ record.disclosurE_TYPE }}</span>
                    </div>
                    <div class="mb-2">
                      <span class="text-muted mr-1">{{ 'madisonphi.nameLabel' | translate }}</span>
                      <span class="text-muted">{{ record.discloseD_TO }}</span>
                    </div>
                    <div>
                      <span class="text-muted mr-1">{{ 'madisonphi.contactNoLabel' | translate }}</span>
                      <span class="text-muted">{{ record.disclosurE_DESCRIPTION }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #notFoundPA>
        <div class="col-12 mt-4 text-center px-0">
          <p class="mb-0 text-danger">{{ 'madisonphi.noContactsAdded' | translate }}</p>
        </div>
      </ng-template>
    </div>
  </div>
</div>

<!-- New past surgical history Modal -->
<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="newphi">
  <div class="modal-dialog modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ 'madisonphi.modalTitle' | translate }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-row">
          <p>{{ 'madisonphi.modalFooterText' | translate }}</p>
          <div class="col-md-12">
            <div class="form-group ">
              <div class="form-group form-floating">
                <input type="text" class="form-control" placeholder="{{ 'madisonphi.namePlaceholder' | translate }}" [(ngModel)]="madisonPHIdetails.discloseD_TO">
                <label>{{ 'madisonphi.nameLabel' | translate }}</label>
              </div>
            </div>
          </div>


          <div class="col-md-12">
            <div class="form-group">
              <div class="form-select form-floating">
                <select translate="no" class="form-control" [(ngModel)]="madisonPHIdetails. disclosurE_TYPE">
                  <option value="" disabled selected>{{ 'madisonphi.relationshipSelectDefault' | translate }}</option>
                  <option value="Associate">{{ 'madisonphi.relationshipOptions.Associate' | translate }}</option>
                  <option value="Brother">{{ 'madisonphi.relationshipOptions.Brother' | translate }}</option>
                  <option value="Care giver">{{ 'madisonphi.relationshipOptions.CareGiver' | translate }}</option>
                  <option value="Handicapped dependent">{{ 'madisonphi.relationshipOptions.HandicappedDependent' | translate }}</option>
                  <option value="Life partner">{{ 'madisonphi.relationshipOptions.LifePartner' | translate }}</option>
                  <option value="Emergency dependent">{{ 'madisonphi.relationshipOptions.EmergencyDependent' | translate }}</option>
                  <option value="Employee">{{ 'madisonphi.relationshipOptions.Employee' | translate }}</option>
                  <option value="Extended Family">{{ 'madisonphi.relationshipOptions.Extended Family' | translate }}</option>
                  <option value="Foster">{{ 'madisonphi.relationshipOptions.Foster' | translate }}</option>
                  <option value="Friend">{{ 'madisonphi.relationshipOptions.Friend' | translate }}</option>
                  <option value="Father">{{ 'madisonphi.relationshipOptions.Father' | translate }}</option>
                  <option value="Grandchild">{{ 'madisonphi.relationshipOptions.Grandchild' | translate }}</option>
                  <option value="Guardian">{{ 'madisonphi.relationshipOptions.Guardian' | translate }}</option>
                  <option value="Grandparent">{{ 'madisonphi.relationshipOptions.Grandparent' | translate }}</option>
                  <option value="Manager">{{ 'madisonphi.relationshipOptions.Manager' | translate }}</option>
                  <option value="Mother">{{ 'madisonphi.relationshipOptions.Mother' | translate }}</option>
                  <option value="Natural child">{{ 'madisonphi.relationshipOptions.NaturalChild' | translate }}</option>
                  <option value="None">{{ 'madisonphi.relationshipOptions.None' | translate }}</option>
                  <option value="Other adult">{{ 'madisonphi.relationshipOptions.OtherAdult' | translate }}</option>
                  <option value="Other">{{ 'madisonphi.relationshipOptions.Other' | translate }}</option>
                  <option value="Owner">{{ 'madisonphi.relationshipOptions.Owner' | translate }}</option>
                  <option value="Parent">{{ 'madisonphi.relationshipOptions.Parent' | translate }}</option>
                  <option value="Stepchild">{{ 'madisonphi.relationshipOptions.Stepchild' | translate }}</option>
                  <option value="Self">{{ 'madisonphi.relationshipOptions.Self' | translate }}</option>
                  <option value="Sibling">{{ 'madisonphi.relationshipOptions.Sibling' | translate }}</option>
                  <option value="Sister">{{ 'madisonphi.relationshipOptions.Sister' | translate }}</option>
                  <option value="Spouse">{{ 'madisonphi.relationshipOptions.Spouse' | translate }}</option>
                  <option value="Trainer">{{ 'madisonphi.relationshipOptions.Trainer' | translate }}</option>
                  <option value="Unknown">{{ 'madisonphi.relationshipOptions.Unknown' | translate }}</option>
                  <option value="Ward of count">{{ 'madisonphi.relationshipOptions.WardOfCount' | translate }}</option>
                </select>

                <label>{{ 'madisonphi.relationshipLabel' | translate }}<span class="text-danger"></span></label>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="form-group">
              <div class="form-group form-floating">
                <input type="text" class="form-control" placeholder="{{ 'madisonphi.contactNoPlaceholder' | translate }}" [(ngModel)]="madisonPHIdetails.disclosurE_DESCRIPTION"
                       (input)="validatePhoneNo($event.target);validatePhone($any($event.target).value ,'phone')" maxlength="14" />
                <label>{{ 'madisonphi.contactNoLabel' | translate }}</label>
              </div>
              <span *ngIf="isNotValidPhone" class="err">{{ 'madisonphi.contactNoMinDigitsError' | translate }}</span>
            </div>
          </div>
          <div class="border-bottom border-left border-right border-top-0" style="padding: 10px;">
            <div class="custom-control custom-checkbox">
              <input #agree class="custom-control-input" type="checkbox" id="idCheck">
              <label class="custom-control-label" for="idCheck">{{ 'madisonphi.doNotReleaseInfoText' | translate }}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary" data-dismiss="modal">{{ 'madisonphi.cancelButton' | translate }}</button>
        <button type="button" class="btn btn-primary" (click)="savePHIdeTails()">{{ 'madisonphi.saveButton' | translate }}</button>
      </div>
    </div>
  </div>
</div>

<!-- Delete PHI Modal -->
<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="delPHI">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="font-weight-bolder mb-3 text-danger">{{ 'madisonphi.deletePHITitle' | translate }}</h5>
        <button type="button" class="btn btn-outline-primary mr-2" data-dismiss="modal">{{ 'madisonphi.cancelButton' | translate }}</button>
        <button type="button" (click)="savePHIdeTails()" class="btn btn-primary">{{ 'madisonphi.deleteButton' | translate }}</button>
      </div>
    </div>
  </div>
</div>

<footer class="p-3">
  <div class="container p-0">
    <div class="text-right">
      <button type="button" class="btn btn-primary" (click)="nextComp()">{{ 'madisonphi.nextButton' | translate }}</button>
    </div>
  </div>
</footer>
